import { adminApi } from './admin-api';
import type { PlatformSetting, FeatureFlag, AuditLogEntry, ApiResponse, PaginatedResponse, AdminFilters, AdminAuthResponse } from '@/types/admin.types';

export const adminSettingsService = {
  login: async (email: string, password: string): Promise<ApiResponse<AdminAuthResponse>> => {
    const response = await adminApi.post('/auth/login', { email, password });
    return response.data;
  },

  getProfile: async (): Promise<ApiResponse<AdminAuthResponse['user']>> => {
    const response = await adminApi.get('/users/profile');
    return response.data;
  },

  getSettings: async (): Promise<PlatformSetting[]> => {
    const response = await adminApi.get('/admin/settings');
    return response.data;
  },

  updateSetting: async (key: string, value: unknown): Promise<PlatformSetting> => {
    const response = await adminApi.patch(`/admin/settings/${key}`, { value });
    return response.data;
  },

  getFeatureFlags: async (): Promise<FeatureFlag[]> => {
    const response = await adminApi.get('/admin/settings/feature-flags');
    return response.data;
  },

  toggleFeatureFlag: async (key: string): Promise<FeatureFlag> => {
    const response = await adminApi.post(`/admin/settings/feature-flags/${key}/toggle`);
    return response.data;
  },

  createFeatureFlag: async (data: Omit<FeatureFlag, 'key'> & { key: string }): Promise<FeatureFlag> => {
    const response = await adminApi.post('/admin/settings/feature-flags', data);
    return response.data;
  },

  getAuditLogs: async (filters: AdminFilters = {}): Promise<PaginatedResponse<AuditLogEntry>> => {
    const params = new URLSearchParams();
    if (filters.page) params.set('page', String(filters.page));
    if (filters.limit) params.set('limit', String(filters.limit));
    if (filters.search) params.set('search', filters.search);
    if (filters.dateFrom) params.set('dateFrom', filters.dateFrom);
    if (filters.dateTo) params.set('dateTo', filters.dateTo);
    const response = await adminApi.get(`/admin/settings/audit-log?${params.toString()}`);
    return response.data;
  },
};
